import { useEffect, useState } from 'react'
import { Page, PageContent, PageHeader, Grid, Layer, Spinner, Text } from 'grommet'
import { ReverseAnchor } from '../components/competetive/ReverseAnchor';
import { CustomCard } from '../components/competetive/CustomCard';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { storageService } from '../services/storage';
import { storageActions } from '../redux/actions';
import { analyticsService } from '../services';


function StorageSecondaryPage() {
    const { id, primary_id } = useParams()
    const dispatch = useDispatch();
    const [pageTitle, setPageTitle] = useState('')
    const [anchorTitle, setAnchorTitle] = useState('')
    const session = useSelector((state) => {
        return state.session;
    });
    useEffect(() => {
        if (session && session.user && session.user.access) {
            storageService.getPrimaryById(session.user.access, primary_id).then((response) => {
                setAnchorTitle(response.primary_application_group)
                setPageTitle(response.primary_name + ' Resources')
            })
            dispatch(
                storageActions.getSecondaryForPrimary(session.user.access, primary_id))
        }
    }, [
        session,
        dispatch, primary_id]);

    const secondaryList = useSelector((state) => {
        return state.storageApplication.secondaries
    });
    return <>
        <Page>
            <PageContent>
                {secondaryList.requestInProgress &&
                    <Layer position='center' background='none' style={{ boxShadow: "none" }}>
                        <Spinner />
                    </Layer>
                }

                {
                    <>
                        <PageHeader parent={<ReverseAnchor label={anchorTitle} onClick={() => { window.history.go(-1) }} />} title={pageTitle}
                        />
                        {secondaryList && Array.isArray(secondaryList.data) && secondaryList.data.length > 0 ? <Grid columns={"25%"} gap={"medium"}>
                            {
                                secondaryList.data.map((secondary, index) => (
                                    <CustomCard key={`${index}_${secondary.name}`} title={secondary.name} description={secondary.description} onClickHandler={() => {
                                        analyticsService.logStorageEvent(session.user.access, '5', null, null, secondary.id)
                                        window.open(secondary.link)
                                    }} />
                                ))
                            }
                        </Grid> : secondaryList.requestInProgress ? <Spinner /> : <Text> No Resources available for the selected product</Text>}
                    </>
                }
            </PageContent>
        </Page>
    </>
}

export default StorageSecondaryPage